import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    rootSubmit: {
        background: '#0C8FAD',
        fontFamily: themeCommon.RobotoBold,
        color: "#FFFFFF",
        opacity: 1,
        fontSize: themeCommon.fontSize18px,
        borderRadius: '10px',
        padding: '0 30px',
        height: '50px',
        cursor: 'pointer',
        marginTop: '20px',
        [theme.breakpoints.down('md')]: {
            height: '40px',
            padding: '0 10px',
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            height: '30px',
            padding: '0 5px',
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('xs')]: {
            height: '30px',
            padding: '0px',
            fontSize: themeCommon.fontSize12px,
        },
    },
    rootTitle: {
        fontFamily: themeCommon.RobotoBold,
        fontSize: themeCommon.fontSize22px,
        margin: '10px 0',
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize18px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    rootDescription: {
        margin: '10px 0',
        fontSize: themeCommon.fontSize20px,
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize10px,
        },
    },
    rootAnswers: {
        marginLeft: '20px',
    },
    checkbox: {
        color: '#7A7A7A',
    },
    rootTextField: {
        '& > label': {
            fontSize: themeCommon.fontSize16px,
        },

        [theme.breakpoints.down('lg')]: {
            '& > label': {
                fontSize: themeCommon.fontSize16px,
            }
        },
        [theme.breakpoints.down('md')]: {
            '& > label': {
                fontSize: themeCommon.fontSize14px,
                marginTop: '-10px',
            },
            '& > div': {
                height: '35px',
                fontSize: themeCommon.fontSize14px,
            },
        },
        [theme.breakpoints.down('sm')]: {
            '& > label': {
                fontSize: themeCommon.fontSize12px,
                marginTop: '-12px',
            },
            '& > div': {
                height: '30px',
                fontSize: themeCommon.fontSize12px,
            },
        },
    },
    rootSubHeader: {
        fontFamily: themeCommon.RobotoBold,
        fontSize: themeCommon.fontSize18px,
        margin: '10px 0',
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    assessmentBox: {
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)',
        borderRadius: '20px',
        margin: '15px 0 50px !important',
        padding: '20px 20px 50px 20px',
    }
}), {
    name: 'AssessmentHolderHeadContainer',
    index: 1,
})

export default useStyles